import { render, staticRenderFns } from "./bar3dType1.vue?vue&type=template&id=484e3af1&scoped=true&"
import script from "./bar3dType1.vue?vue&type=script&lang=js&"
export * from "./bar3dType1.vue?vue&type=script&lang=js&"
import style0 from "./bar3dType1.vue?vue&type=style&index=0&id=484e3af1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e3af1",
  null
  
)

export default component.exports